/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */ /**
 * Entrypoint for the customize screen itself (the left sidebar).
 */ import "@devowl-wp/utils/lib/antd.scss";
import "./style/admin.scss";
import { applyCustomizeBannerSidebar } from "./others";
applyCustomizeBannerSidebar();
export * from "./store";
